import React from "react";
import { CnpForm, IProduct } from "../../types";
import CustomerInputForm from "./CustomerInputForm/CustomerInputForm";
import FormStep from "../../types/FormStep";
import LineItemInputForm from "./LineItemInputForm/LineItemInputForm";
import { PaymentTerms } from "./PaymentTerms/PaymentTerms";
// eslint-disable-next-line import/no-cycle
import MobileReview from "./NewReview/NewReview";
import Review from "./Review/Review";
import indexModule from "./index.module.scss";

// todo fix any type across project
const getFormConfig = (data: CnpForm, confirmProceed: any, updateData: any, goTo: any) => {
  return [
    {
      component: (
        <CustomerInputForm
          data={data}
          canProceed={confirmProceed}
          updateCustomerData={updateData}
          updateAddressData={updateData}
        />
      ),
      nextButtonText: "Next",
      title: "Add Your Customer's Details",
      stepName: "Customer details",
      shortName: "Customer",
      isFormStepperStep: true,
      previousButtonText: "Back",
      nextIndex: 1,
    },
    {
      component: <LineItemInputForm data={data} canProceed={confirmProceed} updateData={updateData} />,
      nextButtonText: "Next",
      previousButtonText: "Back",
      title: "Add Your Line Items",
      stepName: "Line items",
      shortName: "Items",
      isFormStepperStep: true,
      nextIndex: 2,
      showDockTotals: true,
    },
    {
      component: <PaymentTerms data={data} canProceed={confirmProceed} updateData={updateData} />,
      nextButtonText: "Review",
      previousButtonText: "Back",
      title: "Set Your Payment Terms",
      stepName: "Payment terms",
      shortName: "Terms",
      isFormStepperStep: true,
      nextIndex: 3,
    },
    {
      component: (
        <>
          <div className={indexModule.mobileInvoice}>
            <MobileReview data={data} updateData={updateData} canProceed={confirmProceed} goTo={goTo} />{" "}
          </div>
          <div className={indexModule.nonMobileInvoice}>
            <Review data={data} updateData={updateData} canProceed={confirmProceed} goTo={goTo} />{" "}
          </div>
        </>
      ),
      nextButtonText: "Share",
      previousButtonText: "Back",
      title: "Review",
      stepName: "Review",
    },
    {
      component: <LineItemInputForm data={data} canProceed={confirmProceed} updateData={updateData} />,
      nextButtonText: "Done",
      title: "Edit Your Line Items",
      stepName: "Line items",
      isFormStepperStep: false,
      nextIndex: 3,
      showDockTotals: true,
    },
    {
      component: <PaymentTerms data={data} canProceed={confirmProceed} updateData={updateData} />,
      nextButtonText: "Done",
      title: "Edit Your Payment Terms",
      stepName: "Payment terms",
      isFormStepperStep: false,
      nextIndex: 3,
    },
    {
      component: (
        <CustomerInputForm
          data={data}
          canProceed={confirmProceed}
          updateCustomerData={updateData}
          updateAddressData={updateData}
        />
      ),
      nextButtonText: "Done",
      title: "Edit Your Customer's Details",
      stepName: "Customer details",
      isFormStepperStep: false,
      nextIndex: 3,
    },
  ] as FormStep[];
};

const INITIAL_DATA = {
  customerInformation: {
    customerName: "",
    contactNumber: "",
    emailAddress: "",
    billingAddress: {
      country: "",
      city: "",
      postalCode: "",
      streetAddress: "",
      suburb: "",
      province: "",
      complexBuilding: "",
    },
  },
  lineItems: [] as Array<IProduct>,
  paymentTerms: {
    dueDate: new Date().toISOString(),
    additionalNotes: "",
    invoiceNumber: "",
  },
} as CnpForm;

export { getFormConfig, INITIAL_DATA };
